import { render, staticRenderFns } from "./EditNewsFooter.vue?vue&type=template&id=d8985956&scoped=true&"
import script from "./EditNewsFooter.vue?vue&type=script&lang=ts&"
export * from "./EditNewsFooter.vue?vue&type=script&lang=ts&"
import style0 from "./EditNewsFooter.vue?vue&type=style&index=0&id=d8985956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8985956",
  null
  
)

export default component.exports